export default __webpack_public_path__ + "static/appartementen-mobile-2eabcc3017651e347ff3d23676eeefaf.svg";